import { PublicProductListGroupedByCategoryResponse } from "libs/shared-models/src/lib/restaurant/public-product-list-grouped-by-category-response"
import { PublicRestaurantInfo } from "./public-restaurant-info";
import { AddonGroupResponse } from "libs/shared-models/src/lib/restaurant/addon-group-response";

export class PublicRestaurantResponse {
    restaurantInfo: PublicRestaurantInfo = new PublicRestaurantInfo();    
    products: PublicProductListGroupedByCategoryResponse = new PublicProductListGroupedByCategoryResponse();
    addonGroups: AddonGroupResponse[] = [];
}